import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';
import { CURATOR_EVENTS } from '@noths/curator-web';
import { getCuratorSvgUrl, getStaticFilesEnv } from '@noths/polaris-client-static-files';

import * as styles from './Curator.styles';
import type { Environment } from 'client-site-chrome-ui/environment';

export interface CuratorButtonProps extends ComponentPropsWithoutRef<'button'> {
  curatorIconSrc?: string;
  env?: Environment;
  showBadge?: boolean;
  text?: string;
}

const CuratorIcon = ({ env = 'production', src }: { env?: Environment; src?: string }) => {
  const staticFilesEnv = getStaticFilesEnv(env);
  const svgUrl = src || getCuratorSvgUrl(staticFilesEnv, '3001');

  return <img alt="" css={styles.curatorImage} src={svgUrl} />;
};

export const CuratorButton = ({
  'aria-label': ariaLabel = 'Ask The Curator',
  curatorIconSrc,
  env,
  showBadge = true,
  text = 'Ask The Curator',
  type = 'button',
  ...buttonProps
}: CuratorButtonProps) => {
  const handleCuratorToggle = () => {
    // the page which has the Curator component will listen for this event and toggle the curator state
    document.dispatchEvent(new CustomEvent(CURATOR_EVENTS.TOGGLE_CURATOR));
  };

  // keep this for now - we may decide to remove this badge once we have more confidence in the Curator component
  const badgeText = 'Beta';

  return (
    <button
      aria-label={ariaLabel}
      css={styles.button}
      type={type}
      {...buttonProps}
      onClick={handleCuratorToggle}
    >
      <div css={styles.iconWrapper}>
        <CuratorIcon env={env} src={curatorIconSrc} />
      </div>
      <div css={styles.textWrapper}>
        <p css={styles.text}>{text}</p>
      </div>
      {showBadge && (
        <div css={styles.badge}>
          <p css={styles.badgeText}>{badgeText}</p>
        </div>
      )}
    </button>
  );
};
